import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Series } from './Model';
import { Card, Box, CardContent } from '@mui/material';

export function SeriesListContext(props: {item: Series}) {
  return (
    <>
        <Card sx={{ display: 'flex', flex: 'auto' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', width: '90%'  }}>
                <CardContent sx={{ flex: 'auto' }}>
                    <Typography component="div" variant="h5">
                       {props.item.title}
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        component="div"
                        sx={{ color: 'text.secondary' }}
                    >
                        {props.item.subtitle}
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        component="div"
                        sx={{ color: 'text.secondary' }}
                    >
                        {props.item.description}
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        component="div"
                        sx={{ color: 'text.secondary' }}
                    >
                        {props.item.author}
                    </Typography>
                </CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1 }}>
                </Box>
            </Box>
        </Card>
    </>
  );
}